import { UseFormReturn } from "react-hook-form";
import { IModuleRound } from "../../../modules/roundHandler";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleVärmePrimärFjärrRound } from "../../../types/ModuleDatas";
import NumberEditor from "../../Global/Editors/NumberEditor";
import { nameof } from "../../Global/Utils";
import { MapTooltip } from "../../../types/globalData";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundVarmePrimarFjarr = ({ module, data, formHook }: IProps) => {
  const saknarMätvarde = formHook.watch(nameof<IModuleVärmePrimärFjärrRound>("saknarMätvärde"));

  const harMätvarde = saknarMätvarde === "Nej";
  if (!saknarMätvarde) {
    formHook.setValue(nameof<IModuleVärmePrimärFjärrRound>("saknarMätvärde"), "Nej");
  }

  return (
    <>
      <div className="row ml-0">
        <div className="col-lg-12">
          <SelectEditor
            label="Ange om mätvärden från fjärrvärmemätaren saknas"
            formHook={formHook}
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("saknarMätvärde")}
            items={["Nej", "Ja"]}
          ></SelectEditor>
        </div>
        {harMätvarde ? (
          <>
            <div className="col-lg-6">
              <NumberEditor
                label="Värmemängdsmätare Fjärrvärme m³ ackumulerat 12 månaders värde"
                fieldName={nameof<IModuleVärmePrimärFjärrRound>("mätvärdeM3")}
                tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_mätvärdeM3")}
                formHook={formHook}
                revalidateFields={[nameof<IModuleVärmePrimärFjärrRound>("mätvärdeMWh")]}
                options={{
                  validate: {
                    required: (value: any) => value || "Måste anges",
                    plausibleQW: (value: any) => {
                      const mwh = formHook.getValues(nameof<IModuleVärmePrimärFjärrRound>("mätvärdeMWh"));
                      if (!mwh) return true;
                      const r = value / mwh;
                      return (r >= 5 && r <= 100) || "Orimligt QW-tal (m³/MWh 5–100)";
                    },
                  },
                }}
              ></NumberEditor>
            </div>
            <div className="col-lg-6">
              <NumberEditor
                label="Värmemängdsmätare Fjärrvärme MWh ackumulerat 12 månaders värde"
                fieldName={nameof<IModuleVärmePrimärFjärrRound>("mätvärdeMWh")}
                tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_mätvärdeMWh")}
                formHook={formHook}
                revalidateFields={[nameof<IModuleVärmePrimärFjärrRound>("mätvärdeM3")]}
                options={{
                  validate: {
                    required: (value: any) => value || "Måste anges",
                    plausibleQW: (value: any) => {
                      if (!value) return true;
                      const m3 = formHook.getValues(nameof<IModuleVärmePrimärFjärrRound>("mätvärdeM3"));
                      if (!m3) return true;
                      const r = m3 / value;
                      return (r >= 5 && r <= 100) || "Orimligt QW-tal (m³/MWh 5–100)";
                    },
                  },
                }}
              ></NumberEditor>
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="col-lg-12">
          <NumberEditor
            label="Temperatur utegivare °C"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("temperaturUtegivare")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_temperaturUtegivare")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>

        <div className="col-lg-6">
          <NumberEditor
            label="Tilloppstemp primärsida(°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("tilloppstempPrimär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_tilloppstempPrimär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Returtemp primärsida(°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("returTempPrimär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_returTempPrimär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Tilloppstemp sekundärsida (°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("tilloppstempSekundär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_tilloppstempSekundär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Returtemp sekundärsida (°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("returTempSekunär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_returTempSekunär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
      </div>
      <BFLNote formHook={formHook} />
    </>
  );
};

export default RoundVarmePrimarFjarr;
